import React from "react";
import { numberFormat } from "../../../../Utils";

const CancellationInformation = ({ membershipData }) => {
  return (
    <>
      <b>IMPORTANT: Cancellation Information</b>
      <br />
      You are attempting to cancel your{" "}
      <strong>{membershipData.tier_name}</strong> without meeting the minimum
      time commitment. An early termination fee of{" "}
      <strong>
        {numberFormat(membershipData.early_cancellation_fee, "currency")}
      </strong>{" "}
      will be assessed today if you choose to cancel.
      <br />
      Would you like to continue?
    </>
  );
};

export default CancellationInformation;
